import { EntityConfig } from "../../../../types/EntityConfig";


export const AcabamentosConfig : EntityConfig = [
    {
        id: 'id',
        label: 'Id',
        type: 'id',
        nonEditable: true,
        hidden: true
    },
    {
        id: 'observacoes',
        label: 'Observações',
        type: 'text'
    },
    {
        id: 'isExternal',
        label: 'Operação externa',
        type: 'boolean',
        filterable: true,
    },
    {
        id: 'dataExpedicao',
        label: 'Data de saída',
        type: 'date',
        conditional : (form : any)  => form?.isExternal 
    }

]